// extracted by mini-css-extract-plugin
export default {"bgspace":"style_bgspace__gS3rj"};